module.exports = __webpack_public_path__ + "static/media/balarm.810c91a7.png";